/** @format */

import { AnimationMySelogerPro, Container } from "./Loader.styled"
import { useEffect, useState } from "react"

import { LoaderProp as LoaderProps } from "./Loader.types"
import React from "react"

const DURATION = 1000
const Loader = ({ visible, fadeoutDuration, isSticky }: LoaderProps) => {
	type stateType = "visible" | "leaving" | "hidden"

	const [state, setState] = useState<stateType>(visible ? "visible" : "hidden")

	if (!fadeoutDuration) {
		fadeoutDuration = DURATION
	}
	if (isSticky !== true) {
		isSticky = false
	}

	useEffect(() => {
		if (!visible) {
			setState("leaving")
		} else {
			setState("visible")
		}
	}, [visible])

	useEffect(() => {
		if (state === "leaving") {
			if (fadeoutDuration > 0) {
				const timer = setTimeout(() => {
					setState("hidden")
				}, fadeoutDuration)
				return () => {
					clearTimeout(timer)
				}
			} else {
				setState("hidden")
			}
		}
	}, [state, fadeoutDuration])

	if (state === "hidden") return null
	return (
		<Container
			transitionMs={fadeoutDuration}
			opacity={state === "visible" ? 1 : 0}
			data-testid="myslp-loader-container"
			isSticky={isSticky}
		>
			<AnimationMySelogerPro data-testid="myslp-loader-animation" />
		</Container>
	)
}

export default Loader
